import {applyMiddleware, combineReducers, compose, createStore} from 'redux';
import {createBrowserHistory} from 'history';
import {connectRouter, routerMiddleware} from 'connected-react-router';
import createSagaMiddleware from 'redux-saga';
import reducers from 'bukku/redux/reducers';
import rootSaga from 'bukku/redux/sagas';
import {getPrompt} from "bukku/components/Prompt";

const history = createBrowserHistory({
    getUserConfirmation(message, callback) {
        getPrompt(message, callback);
    },
});

// const logger = store => next => action => {
//     console.group(action.type);
//     console.info('dispatching', action);
//     const result = next(action);
//     console.log('next state', store.getState());
//     console.groupEnd();
//     return result;
// };

const sagaMiddleware = createSagaMiddleware();
const routeMiddleware = routerMiddleware(history);
const middlewares = [sagaMiddleware, routeMiddleware];
// const middlewares = [sagaMiddleware, routeMiddleware, logger];

const composeEnhancers =
    // eslint-disable-next-line no-underscore-dangle
    typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
        // eslint-disable-next-line no-underscore-dangle
        window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
            // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
            trace: true,
            actionsDenylist: [
                'APP_TOGGLE_SESSION_TIMEOUT',
            ],
        }) :
        compose;

const store = createStore(
    combineReducers({
        ...reducers,
        router: connectRouter(history),
    }),
    composeEnhancers(applyMiddleware(...middlewares)),
);
sagaMiddleware.run(rootSaga);
export { store, history };
